import { mapActions, mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";

export default {
  data() {
    return {
      loadingSubscribers: [],
    };
  },
  computed: {
    ...mapFields('subscriber', {
      subscriberIds: 'allIds',
      subscriberIdsCached: "cacheAllIds",
      deletedSubscriberItem: 'deleted',
      subscriberHandled: 'handled',
      subscriberActionHandled: 'handleAction'
    }),
    ...mapGetters('subscriber', { findSubscriber: 'find' }),
  },
  methods: {
    ...mapActions('subscriber', {
      retrieveSubscriber: 'load',
      deleteSubscriber: 'del',
      updateSubscriber: 'update',
    }),
    resolveSubscriberItems(itemIds, force = false) {
      if (typeof itemIds === "undefined") {
        return [];
      }
      return itemIds.map((itemId) => {
        if (force || !this.subscriberIdsCached.includes(itemId) && !this.loadingSubscribers.includes(itemId)) {
          this.loadingSubscribers.push(itemId);
          this.retrieveSubscriber(decodeURIComponent(itemId));
        }
        return this.findSubscriber(itemId);
      }).filter(e => e);
    },
    resolveSubscriber(itemId) {
      if (!this.subscriberIdsCached.includes(itemId) && !this.loadingSubscribers.includes(itemId)) {
        this.loadingSubscribers.push(itemId);
        this.retrieveSubscriber(decodeURIComponent(itemId));
      }
      return this.findSubscriber(itemId);
    },
  }
};
